import { useState } from 'react';
import { groupReactions } from '../utils/groupReactions';
import { Reaction } from '../../../../generated/graphql';

export const useReactionsBar = ({
  maxIcons,
  allReactions,
}: {
  maxIcons: number;
  allReactions: Reaction[];
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const emojiReactions = (allReactions || []).filter(
    (i) => i.type !== 'Comment',
  );
  const [first, rest] = groupReactions(emojiReactions, maxIcons);
  const visibleReactions = isVisible ? [...first, ...rest] : first;

  const toggleAllReactionsVisible = () => setIsVisible((s) => !s);

  return {
    allReactionsVisible: isVisible,
    toggleAllReactionsVisible,
    visibleReactions,
    restReactionsCount: rest.length,
  };
};
